import React, { HTMLAttributes, PropsWithChildren } from 'react'

import { HeadMetadata } from '@components/head-metadata'
import { Container } from '@components/admin/container'
import { SideBar } from '@components/admin/side-bar'
import { InnerContainer } from '@components/admin/inner-container'
import { FlatHeader } from '@components/admin/flat-header'
import { FlatFooter } from '@components/admin/flat-footer'
import { PageTitle } from '@components/admin/page-title'

const DEFAULT_TITLE = 'Portal Solar - Portal de Notícias'
const DEFAULT_META_TITLE = 'Portal Solar - Portal de Notícias'
const DEFAULT_META_DESCRIPTION =
  'Acompanhe notícias sobre tecnologia, regulação, projetos, indicadores. Conheça mais sobre o site Portal Solar'
const DEFAULT_CANONICAL_URL = 'http://localhost:4000'
// const DEFAULT_CANONICAL_URL = 'https://www.portalsolar.com.br'

interface FlatSkeletonProps extends HTMLAttributes<HTMLDivElement> {
  subTitle?: string
  title?: string
  head?: {
    metaTitle?: string
    metaDescription?: string
    canonicalUrl?: string
  }
  isLoading?: boolean
}

export const FlatSkeleton = ({
  head = {},
  children,
  title,
  subTitle,
  isLoading = false,
  ...rest
}: PropsWithChildren<FlatSkeletonProps>) => {
  return (
    <div className=" flex flex-col flex-nowrap min-h-screen">
      <FlatHeader />

      <HeadMetadata
        title={head.metaTitle || DEFAULT_TITLE}
        metaTitle={head.metaTitle || DEFAULT_META_TITLE}
        metaDescription={head.metaDescription || DEFAULT_META_DESCRIPTION}
        canonicalUrl={head.canonicalUrl || DEFAULT_CANONICAL_URL}
      />

      <Container {...rest}>
        <SideBar />

        <InnerContainer>
          {title && <PageTitle title={title} subTitle={subTitle} />}
          {!isLoading && children}
        </InnerContainer>
      </Container>
      <FlatFooter />
    </div>
  )
}
